import React, { Component } from 'react';
import closeIcon from '../../../assets/icons/icon_close.svg';
var classNames = require('classnames');

class ReadOnlyInput extends Component{

  constructor(props) {
    super(props);
    this.state = {
      infoActive: false
    }
  }

  handleInfoModal = () => {
    const infoModal = this.refs.infoModal;
    const activeState = this.state.infoActive;
    const section = this.refs.section;
    if (infoModal !== undefined && section !== undefined){
      if(activeState){
        infoModal.classList.remove(this.props.styles.infoModalActive)
        section.classList.remove(this.props.styles.containerRotate)
        this.setState({
          infoActive: false
        })
      }
      else{
        infoModal.classList.add(this.props.styles.infoModalActive)
        section.classList.add(this.props.styles.containerRotate)
        this.setState({
          infoActive: true
        })
      }
    }
  }

  render() {
    const styles = this.props.styles;
    const fullWidthStyleClass = this.props.fullWidth === "true" ? styles.full : '';
    const separator = (this.props.currency !== undefined && this.props.unitInfo ) ? " / " : "";
    const localisedNumber = this.props.floatValue ? this.props.value : Number(parseFloat(this.props.value).toFixed(2)).toLocaleString('de-DE');
    const isHighlightedBoxStyles = this.props.highlightBox ? styles.highlight : null;
    return(
      <div ref="section" className={classNames(styles.inputItem, fullWidthStyleClass, isHighlightedBoxStyles)}>
        <div className={styles.info}>
          {this.props.helpText &&
            <div>
              <img src={this.props.icon} alt="Info" onMouseDown={this.handleInfoModal} />
              <div className={styles.infoModal} ref="infoModal" onMouseDown={this.handleInfoModal}>
                <h5>{this.props.description}</h5>
                <p>{this.props.helpText}</p>
                <img src={closeIcon} alt="Info" onMouseDown={this.handleInfoModal} />
              </div>
            </div>
          }
        </div>
        <input
          type={this.props.type}
          className={styles.inputField}
          placeholder={localisedNumber}
          disabled="disabled"
        />
        <span>
          {this.props.currency !== undefined && this.props.currency.symbol} {separator} {this.props.unitInfo}
        </span>
        <span className={styles.bottom}>
          {this.props.description}
        </span>
      </div>
    );
  }
}

export default ReadOnlyInput;



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_readonly_input.js